import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronLeft from '@/icons/SiChevronLeft';
import { useBundle } from '@/services/bundles/useBundleService';
import { useCustomerRoutePrefix } from '@/services/customer/useCustomerRoutePrefix';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import CreateEditBundleForm, { CreateEditBundleSubmitData } from './CreateEditBundleForm';

interface CustomerBundlesProps {}

const CreateBundle: FunctionComponent<CustomerBundlesProps> = () => {
  const routePrefix = useCustomerRoutePrefix();

  const myBundlePageRoute = `${routePrefix}/bundles`;

  const navigate = useNavigate();

  const breadcrumbs: NavPage[] = [
    {
      name: 'Bundles',
      to: myBundlePageRoute
    },
    {
      name: 'Create New Bundle',
      to: ``
    }
  ];

  const createBundle = useBundle(state => state.createBundle);

  const onSubmit = async (data: CreateEditBundleSubmitData) => {
    await createBundle({
      name: data.name,
      mainDevice: data.mainDeviceId,
      bundledItems: data.peripherals.map(peripheral => {
        return {
          catalogItem: peripheral.id,
          count: peripheral.count
        };
      })
    });
    navigate(myBundlePageRoute);
  };

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title={'Create New Bundle'} breadcrumbs={breadcrumbs}>
        <div className="flex gap-4">
          {/*<HelpButton />*/}
          <Button
            onClick={() => {
              navigate(myBundlePageRoute);
            }}
            variant={ButtonVariant.Mono}
          >
            <SiChevronLeft className="text-xl" />
            <span>Back to Bundle Overview</span>
          </Button>
        </div>
      </CataloguePageHeader>
      <CreateEditBundleForm onSubmitCallback={onSubmit} />
    </div>
  );
};

export default CreateBundle;
